import { useState, useEffect, useRef } from "react";
import Accordion from "../features/common/Accordion";
import CustomDropdown from "./CustomDropdown";
import "./Style.css";
import { useSelector, useDispatch } from "react-redux";
import { getInterviewConfigLookups } from "../../application/services/interviewConfigService";
import { updateInterviewConfigData } from "../../store/interviewConfigReducer";

const InterviewConfigMain = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("All");
  const categoryOption = useSelector(
    (state) => state.interviewconfig.categoryOption
  );
  const hasFetched = useRef(false);
  
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    
    const fetchLookups = async () => {
      try {
        const response = await getInterviewConfigLookups();

        dispatch(
          updateInterviewConfigData({
            categoryOption: response.category?.data || [],
            industryOption: response.industry_type?.data || [],
            interviewRoleOption: response.interview_role?.data || [],
          })
        );
      } catch (error) {
        console.error("Lookup fetch failed:", error);
      }
    };

    if (!categoryOption || categoryOption.length === 0) {
      fetchLookups();
    }
  }, [dispatch]);

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);
  };

  const formattedCategoryOptions = (categoryOption || []).map((item) => ({
    value: item.id,
    label: item.value,
  }));

  const filterOptions = [
    { value: "All", label: "All" },
     ...formattedCategoryOptions,
  ];

  return (
    <div className="interview-config-main-container">
      <div className="interview-config-main-header">
        <div className="interview-config-main-header-content">
          <h2 className="interview-config-main-title">Interviews</h2>
          <div className="interview-config-main-filter-container">
            <CustomDropdown
              value={filter}
              options={filterOptions}
              onChange={handleFilterChange}
            />
          </div>
        </div>
      </div>
      <div className="interview-config-main-content">
        <Accordion selectedTab={filter} />
      </div>
    </div>
  );
};

export default InterviewConfigMain;
